import FJActionConstant from '../../constant/FJActionConstant';
import FJCanvasStore from "../../store/FJCanvasStore";
import FJCoreUtil from "../../core/util/FJCoreUtil";
import {FJTimeLineAction, FJToolbarAction} from './FJRoot.action'
import FJConfig from "../../config/FJConfig";
import FJTimelineStore from "fj-timeline";
import FJEventConstant from "../../constant/FJEventConstant";

let FJPreviewAction = (function () {

  return {

    /**
     * @description 设置播放
     * @returns {Function}
     */
    setVideoPlayAction: function () {
      return (dispatch, getState) => {

        const state = getState();
        const timeline = state.timeline;
        const {PLAY, GET_ALL_DURATION} = FJCanvasStore.command;
        if (timeline.currentTime >= FJConfig.maxLimitTime) {
          dispatch(this.setVideoPauseAction());
          return
        }

        FJCanvasStore.executeSync(PLAY, (isPlaying, progress) => {
          if (!isPlaying) {
            dispatch(this.changeVideoPlayingStatusAction(0));
            dispatch(FJToolbarAction.updateToolbarAction());
          }
          dispatch(this.setVideoCurrentTimeAction(progress * FJCanvasStore.executeSync(GET_ALL_DURATION)));
        });
        dispatch(this.changeVideoPlayingStatusAction(1));
        dispatch(FJTimeLineAction.setTimelineAdsorptionAction([]));
      }
    },

    /**
     * @description 设置stop
     * @returns {Function}
     */
    setVideoPauseAction: function () {
      return (dispatch, getState) => {
        const {PAUSE, IS_PLAYING} = FJCanvasStore.command;
        const isPlaying = getState().preview.isPlaying;
        if (FJCanvasStore.executeSync(IS_PLAYING) || isPlaying) {
          FJCanvasStore.executeSync(PAUSE);
          dispatch(this.changeVideoPlayingStatusAction(0));
          dispatch(FJToolbarAction.updateToolbarAction());
        }
      }
    },

    /**
     * @description 设置快退
     * @returns {Function}
     */
    setVideoFastRewindAction: function (type) {
      return (dispatch, getState) => {
        const state = getState();
        const timeline = state.timeline;
        let currentProgress = (timeline.currentTime - 1 / FJConfig.fps) / timeline.duration;
        currentProgress = FJCoreUtil.valueOfInterval(currentProgress, 0, 1);
        dispatch(this.setVideoProcessAction(type, currentProgress, {isPercent: true, flush: true, useThrottle: false}));
      }
    },

    /**
     * @description 设置快进
     * @returns {Function}
     */
    setVideoFastForwardAction: function (type) {
      return (dispatch, getState) => {
        const state = getState();
        const timeline = state.timeline;
        let currentProgress = (timeline.currentTime + 1 / FJConfig.fps) / timeline.duration;
        currentProgress = FJCoreUtil.valueOfInterval(currentProgress, 0, 1);
        dispatch(this.setVideoProcessAction(type, currentProgress, {isPercent: true, flush: true, useThrottle: false}));
      }
    },

    /**
     * @description 设置进度
     * @param {string} type
     * @param {number} progress
     * @param {object} options
     * @param {boolean} options.isPercent 是否为百分比
     * @param {boolean} options.flush 是否需要吸附
     * @param {boolean} options.useThrottle 是否使用节流
     * @returns {Function}
     */
    setVideoProcessAction: function (type, progress, options = {
      isPercent: true,
      flush: false,
      useThrottle: true
    }) {
      return (dispatch) => {
        let {isPercent, flush, useThrottle} = options
        let {SEEK, GET_ALL_DURATION} = FJCanvasStore.command;
        let {maxLimitTime} = FJConfig;
        let allDuration = FJCanvasStore.executeSync(GET_ALL_DURATION);
        let seekTime = isPercent ? progress * allDuration : progress;
        seekTime = FJCoreUtil.valueOfInterval(seekTime, 0, Math.min(allDuration, maxLimitTime));
        let func = (type, value, flush, useThrottle) => {
          FJCanvasStore.execute(SEEK, type, seekTime, false, flush, useThrottle).then((adsorptionValue) => {
            dispatch(FJTimeLineAction.setTimelineAdsorptionAction(adsorptionValue === -1 ? []
              : [FJTimelineStore.timeToPixel(adsorptionValue)]));

            // 加入判断是因为store里end阶段并没有进行吸附处理
            if (type !== 'end') {
              dispatch(this.setVideoCurrentTimeAction(adsorptionValue === -1 ? seekTime : adsorptionValue));
            }
          }).catch(() => {
            console.log('setVideoProcessAction error');
          });

          if (type !== 'end') {
            dispatch(this.setVideoCurrentTimeAction(seekTime));
          }
        };
        switch (type) {
          case 'start':
          case 'change':
            func(type, seekTime, flush, useThrottle)
            break;
          case 'end':
            func(type, seekTime, flush, false);
            dispatch(FJToolbarAction.updateToolbarAction());
            dispatch(FJTimeLineAction.updateCopyStatusAction());
            dispatch(FJTimeLineAction.updatePasteStatusAction());
            dispatch(FJTimeLineAction.updateSplitStatusAction());

            // TODO 因为end需要做特殊业务，所有类型的地方不能只发送change
            // 加入异步是因为时间线组件中进度变化后会触发change
            // 确保end在change后执行
            setTimeout(() => {
              window.FJEvent.dispatch(FJEventConstant.TRIGGER_AUTO_EDGE_SCROLL, {});
            }, 10)
            break;
          default:
        }
      }
    },

    /**
     * @description 设置当前的播放进度的时间
     * @param time
     * @returns {{data: *, type: string}}
     */
    setVideoCurrentTimeAction: function (time) {
      return {
        type: FJActionConstant.SET_VIDEO_CURRENT_TIME,
        data: time
      }
    },

    /**
     * @description 更新预览进度
     * @param progress
     * @return {{data: *, type: string}}
     */
    updateVideoPreviewProcessAction: function (progress) {
      return {
        type: FJActionConstant.SET_VIDEO_PREVIEW_TIME,
        data: progress * FJCanvasStore.executeSync(FJCanvasStore.command.GET_ALL_DURATION)
      }
    },

    /**
     * @description 改变播放状态
     * @param num 1：正在播放
     * @returns {{data: *, type: string}}
     */
    changeVideoPlayingStatusAction: function (num) {
      return {
        type: FJActionConstant.CHANGE_VIDEO_PLAYING_STATUS,
        data: num
      };
    },
  }
})();

export default FJPreviewAction;
